import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Benefits from "../components/Benefits";
import Process from "../components/Process";
import Transparency from "../components/Transparency";
import FAQ from "../components/FAQ";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#fcfbf6]">
      <Header />
      <main>
        <Hero />
        <Benefits />
        <Process />
        <Transparency />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
